/**
 * Created by Claude on 08.03.2026
 */

const IslandDecorationWindow = Prefab.createWindow(
    "island_decoration_main_window",
    "island_decoration_window_prefab_json",
    {
        bundles: (mission) => {
            const period = mission.logic.period;
            const names = [`island_decoration_items_${period}`, `island_decoration_illustrations_${period}`];

            const decor = IslandDecorationHelper.getDecorBundle(period);
            if (decor) {
                names.push(decor.name);
            }

            return names;
        }
    }
);
